import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../../lib/api";
import { Lock, User as UserIcon, LogIn, AlertCircle } from "lucide-react";

export default function AdminLogin() {
  const nav = useNavigate();
  const [form, setForm] = useState({ username: "", password: "" });
  const [state, setState] = useState("idle");
  const [err, setErr] = useState("");

  useEffect(() => {
    const t = localStorage.getItem("rs_admin_token");
    if (t) nav("/admin/dashboard", { replace: true });
  }, [nav]);

  const onSubmit = async (e) => {
    e.preventDefault();
    setState("sending"); setErr("");
    try {
      const res = await api.adminLogin(form.username, form.password);
      localStorage.setItem("rs_admin_token", res.token);
      localStorage.setItem("rs_admin_user", res.username);
      nav("/admin/dashboard", { replace: true });
    } catch (e) {
      setState("idle");
      setErr(e?.response?.data?.detail || "Invalid credentials");
    }
  };

  return (
    <div className="min-h-screen bg-ink text-bone flex items-center justify-center p-6">
      <div className="w-full max-w-md">
        <div className="text-center mb-10">
          <div className="font-display-tight text-6xl mb-2">RS<span className="text-amber italic">.</span></div>
          <div className="text-eyebrow text-amber">Admin Console</div>
        </div>
        <form onSubmit={onSubmit} className="border border-line-light p-8 bg-ink-2 space-y-5">
          <div>
            <label className="text-eyebrow text-bone/50 mb-2 block">Username</label>
            <div className="flex items-center gap-3 border border-line-light px-3 focus-within:border-amber transition-colors">
              <UserIcon className="w-4 h-4 text-bone/50" />
              <input required value={form.username} onChange={(e) => setForm({ ...form, username: e.target.value })}
                className="flex-1 bg-transparent py-3.5 text-bone placeholder-bone/30 focus:outline-none" placeholder="admin" />
            </div>
          </div>
          <div>
            <label className="text-eyebrow text-bone/50 mb-2 block">Password</label>
            <div className="flex items-center gap-3 border border-line-light px-3 focus-within:border-amber transition-colors">
              <Lock className="w-4 h-4 text-bone/50" />
              <input required type="password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })}
                className="flex-1 bg-transparent py-3.5 text-bone placeholder-bone/30 focus:outline-none" placeholder="••••••••" />
            </div>
          </div>
          {err && (
            <div className="flex items-start gap-2 text-red-300 text-sm">
              <AlertCircle className="w-4 h-4 mt-0.5" /> {err}
            </div>
          )}
          <button type="submit" disabled={state === "sending"}
            className="w-full bg-amber text-ink py-4 text-[11px] tracking-[0.25em] uppercase font-bold hover:bg-bone transition-colors flex items-center justify-center gap-3 disabled:opacity-60">
            {state === "sending" ? "Signing in…" : "Sign in"}
            <LogIn className="w-4 h-4" />
          </button>
        </form>
        <p className="text-center mt-8 text-bone/40 text-xs tracking-[0.22em] uppercase">Restricted area · authorised personnel only</p>
      </div>
    </div>
  );
}
